import axios from './axiosInstance';
import axiosLib from 'axios';
import { APIAsyncJob } from '../../types';

interface AsyncJobParams {
  sport: string;
  areaId: string;
  asyncJobId: string;
  abortSignal?: AbortSignal;
}

const getAsyncJob = ({ sport, areaId, asyncJobId, abortSignal }: AsyncJobParams): Promise<APIAsyncJob | undefined> => {
  const CancelToken = axiosLib.CancelToken;
  const source = CancelToken.source();
  if (abortSignal) {
    abortSignal.addEventListener('abort', () => {
      source.cancel('Operation canceled by the user.');
    });
  }

  let url = `/${sport}/areas/${areaId}/asyncjobs/${asyncJobId}`;
  return axios.get(url, { cancelToken: source.token })
    .then((response) => {
      return response?.data || undefined;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getAsyncJobDownload = ({ sport, areaId, asyncJobId, abortSignal }: AsyncJobParams): Promise<string> => {
  const CancelToken = axiosLib.CancelToken;
  const source = CancelToken.source();
  if (abortSignal) {
    abortSignal.addEventListener('abort', () => {
      source.cancel('Operation canceled by the user.');
    });
  }

  let url = `/${sport}/areas/${areaId}/asyncjobs/${asyncJobId}/download`;
  return axios.get(url, { cancelToken: source.token })
    .then((response) => {
      return response?.data?.downloadUrl;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};


const asyncJobFunctions = {
  getAsyncJob,
  getAsyncJobDownload,
};

export default asyncJobFunctions;
